import { useContext } from "react";
import { ErrorPage } from "./ErrorPage";
import { AvisContext } from "../context/AvisContext";

interface IForbiddenPageProps {
  showLogoutButton?: boolean;
  showToHomePageButton?: boolean;
}

export function ForbiddenPage(props: Readonly<IForbiddenPageProps>) {
  const { showLogoutButton, showToHomePageButton } = props;
  const { res } = useContext(AvisContext);

  return (
    <ErrorPage
      title={res("error_Title")}
      info={res("error_NoPermissions_Message")}
      showLogoutButton={showLogoutButton}
      showToHomePageButton={showToHomePageButton}
    />
  );
}
